import { Question } from '../types'

export const questions: Question[] = [
  {
    id: 1,
    phase: 'Personalization',
    stepLabel: 'Paso 1 de 15 · Personalización',
    headline: 'Primero, ¿cómo se llama tu perro?',
    type: 'text',
    placeholder: 'Escribe el nombre de tu perro...',
  },
  {
    id: 2,
    phase: 'Personalization',
    stepLabel: 'Paso 2 de 15',
    headline: '¿Cuántos años tiene [nombre]?',
    type: 'single',
    options: [
      { label: 'Menos de 6 años' },
      { label: 'Entre 6 y 8 años' },
      { label: 'Entre 8 y 10 años', tag: 'SENIOR_MEDIO' },
      { label: 'Entre 10 y 12 años', tag: 'SENIOR_ALTO' },
      { label: 'Más de 12 años', tag: 'SENIOR_CRITICO' },
    ],
  },
  {
    id: 3,
    phase: 'Personalization',
    stepLabel: 'Paso 3 de 15',
    headline: '¿Qué tamaño tiene [nombre]?',
    type: 'single',
    options: [
      { label: 'Pequeño (menos de 10kg) — como Chihuahua, Poodle' },
      { label: 'Mediano (10-25kg) — como Beagle, Cocker' },
      { label: 'Grande (más de 25kg) — como Labrador, Pastor' },
    ],
  },
  {
    id: 4,
    phase: 'Pain Identification',
    stepLabel: 'Paso 4 de 15',
    headline:
      '¿Cuál de estas situaciones has notado en [nombre] en los últimos 3 meses?',
    subtext: '(Selecciona todas las que apliquen)',
    type: 'multi',
    options: [
      { label: 'Se cansa rápido en paseos cortos', tag: 'FATIGA' },
      { label: 'Le cuesta subir escaleras o saltar', tag: 'MOVILIDAD' },
      { label: 'Come menos o rechaza su comida a veces', tag: 'APETITO' },
      { label: 'Duerme muchas más horas que antes', tag: 'LETARGO' },
      { label: 'Su pelaje se ve opaco o con caspa', tag: 'PELAJE' },
      { label: 'Ninguna de estas por ahora' },
    ],
  },
  {
    id: 5,
    phase: 'Pain Deepening',
    stepLabel: 'Paso 5 de 15',
    headline:
      "Sé honesto/a... ¿alguna vez has pensado '¿cuánto tiempo más tendrá [nombre]?'",
    type: 'single',
    options: [
      { label: 'Sí, lo pienso seguido — me preocupa mucho', tag: 'DOLOR_ALTO' },
      { label: 'A veces me cruza por la mente', tag: 'DOLOR_MEDIO' },
      { label: 'No tanto, pero empiezo a notarlo', tag: 'DOLOR_BAJO' },
      { label: 'No, está bien por ahora' },
    ],
  },
  {
    id: 6,
    phase: 'Diet',
    stepLabel: 'Paso 6 de 15',
    headline: '¿Qué come [nombre] actualmente?',
    type: 'single',
    options: [
      { label: 'Solo alimento balanceado de supermercado (marca económica)' },
      {
        label: "Alimento balanceado 'premium' o 'senior'",
        tag: 'CROQUETA_PREMIUM',
      },
      { label: 'Mezcla de alimento balanceado + algo de comida casera' },
      { label: 'Solo carne o sobras de comida casera', tag: 'SOLO_CARNE' },
      { label: 'Principalmente comida casera o natural' },
      {
        label: 'No estoy seguro/a de si su comida es la correcta',
        tag: 'CONFUSION_DIETA',
      },
    ],
  },
  {
    id: 7,
    phase: 'Mechanism Belief',
    stepLabel: 'Paso 7 de 15',
    headline:
      '¿Sabías que tanto los alimentos balanceados industriales como darle solo carne a tu perro pueden causar deficiencias nutricionales graves que aceleran su envejecimiento?',
    subtext: '¿Cómo te hace sentir saber esto?',
    type: 'single',
    hasInfoBox: true,
    options: [
      {
        label: 'Me preocupa — [nombre] come así todos los días',
        tag: 'SHOCK_POSITIVO',
      },
      { label: 'Ya lo sospechaba pero no sabía qué hacer' },
      { label: 'No lo sabía, quiero entender más' },
      { label: 'Prefiero no cambiar su dieta por ahora' },
    ],
  },
  {
    id: 8,
    phase: 'Symptom Deepening',
    stepLabel: 'Paso 8 de 15',
    headline: '¿Ha tenido [nombre] alguno de estos problemas de salud?',
    type: 'multi',
    options: [
      { label: 'Problemas digestivos frecuentes (diarrea, estreñimiento)' },
      { label: 'Se rasca mucho o tiene piel irritada' },
      { label: 'Le han detectado algo en riñones o hígado' },
      { label: 'Sobrepeso o dificultad para bajar de peso' },
      { label: 'Articulaciones rígidas o dolor al moverse' },
      { label: 'Ninguno de estos' },
    ],
  },
  {
    id: 9,
    phase: 'Commitment',
    stepLabel: 'Paso 9 de 15',
    headline: '¿Cuánto tiempo llevas con [nombre]?',
    type: 'single',
    options: [
      { label: 'Menos de 3 años' },
      { label: 'Entre 3 y 6 años' },
      { label: 'Entre 6 y 10 años' },
      { label: 'Más de 10 años — es parte de mi familia', tag: 'VINCULO_ALTO' },
    ],
  },
  {
    id: 10,
    phase: 'Failed Solutions',
    stepLabel: 'Paso 10 de 15',
    headline: '¿Qué has intentado para mantener a [nombre] saludable?',
    type: 'multi',
    options: [
      {
        label: "Cambié a alimento balanceado 'supuestamente premium' o 'light'",
      },
      { label: 'Le doy solo carne o pollo pensando que es mejor' },
      { label: 'Le doy suplementos o vitaminas' },
      { label: 'Lo llevé al veterinario pero no mejoró mucho' },
      { label: 'Busqué recetas caseras en internet' },
      { label: 'Todavía no sé por dónde empezar' },
      { label: 'Nada aún — por eso hago este test' },
    ],
  },
  {
    id: 11,
    phase: 'Mechanism Reinforcement',
    stepLabel: 'Paso 11 de 15',
    headline:
      'Los veterinarios confirman que una alimentación equilibrada y natural — ni solo balanceado ni solo carne — puede extender la vida de un perro senior entre 2 y 5 años.',
    subtext:
      '¿Estarías dispuesto/a a cocinar para [nombre] 15-20 minutos al día si eso le diera más años de vida?',
    type: 'single',
    hasInfoBox: true,
    options: [
      {
        label: 'Sí, haría lo que fuera por [nombre]',
        tag: 'COMPRADOR_CALIENTE',
      },
      { label: 'Sí, si es sencillo y con ingredientes normales' },
      { label: 'Tal vez, dependiendo de qué tan fácil sea' },
      { label: 'Prefiero seguir como hasta ahora' },
    ],
  },
  {
    id: 12,
    phase: 'Urgency',
    stepLabel: 'Paso 12 de 15',
    headline:
      '¿Con qué urgencia sientes que necesitas hacer algo por la salud de [nombre]?',
    type: 'single',
    options: [
      { label: 'URGENTE — noto cambios preocupantes ya', tag: 'URGENCIA_ALTA' },
      { label: 'Pronto — quiero actuar antes de que empeore' },
      { label: 'No hay prisa — solo quiero prevenir' },
      { label: 'Solo estoy explorando por ahora' },
    ],
  },
  {
    id: 13,
    phase: 'Identity',
    stepLabel: 'Paso 13 de 15',
    headline: '¿Cómo describirías tu relación con [nombre]?',
    type: 'single',
    options: [
      { label: 'Es mi mejor amigo/a — lo/la quiero como familia' },
      { label: 'Es mi compañero/a de vida diaria' },
      { label: 'Es la alegría de mis hijos o mi hogar' },
      { label: 'Es todo para mí — no imagino mi vida sin él/ella' },
    ],
  },
  {
    id: 14,
    phase: 'Investment',
    stepLabel: 'Paso 14 de 15',
    headline:
      'Si existiera una guía con recetas caseras específicas para perros mayores como [nombre], ¿cuál sería tu mayor motivación?',
    type: 'single',
    options: [
      { label: 'Que viva más tiempo conmigo' },
      { label: 'Que tenga más energía y movilidad' },
      { label: 'Que deje de tener problemas digestivos' },
      { label: 'Que su pelaje y salud mejoren visiblemente' },
      { label: 'Todas las anteriores' },
    ],
  },
  {
    id: 15,
    phase: 'Final',
    stepLabel: 'Paso 15 de 15 — ¡Último paso!',
    headline: 'Una última pregunta importante:',
    subtext:
      'Si hoy descubres exactamente qué está acortando la vida de [nombre] y cómo revertirlo con ingredientes de tu mercado local... ¿Qué harías con esa información?',
    type: 'single',
    options: [
      {
        label: 'La aplicaría HOY MISMO — [nombre] lo merece',
        tag: 'COMPRADOR_INMEDIATO',
      },
      { label: 'La estudiaría y empezaría esta semana' },
      { label: 'No estoy seguro/a todavía' },
    ],
  },
]
